/* eslint-disable no-unused-vars */
import {
  CustomDataTable
} from '@bento-core/data-table';
import { getOptions, getDefaultCustomFooter } from '@bento-core/util';
/**
 * Default configuration for Local Find Upload Modal
 */
export const REVOKE_ACCESS_TABLE_CONFIG = {
  // Misc. Configuration Options
  config: {
  },

  // Helper functions used by the component
  functions: {
    /**
     * Details will be added soon.
     *
     */
    getOptions,

    /**
     * Details will be added soon.
     *
     */
    getDefaultCustomFooter,

    /**
     * Details will be added soon.
     *
     */
    CustomDataTable,
  },
};

export default REVOKE_ACCESS_TABLE_CONFIG;
